module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T WAS LATE")]), _vm._v(" March of 1992 in the Colorado mountains. Ben and Mary West were returning from Mary’s mother’s funeral in Denver, Colorado. They were on I-25 not too far from Colorado Springs when they ran into an unexpected snowstorm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t see the road,” Ben said. “Can you see anything on your side?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary rolled down the window and leaned her head out to try to see the side of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re still on the road, but I can barely see the edge,” Mary said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t want her to know he was starting to get worried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This old Chevy can go through anything. It’s never let us down, and it’s not going to now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned farther over the steering wheel trying to get a better view, but it wasn’t working. The windshield wipers simply couldn’t keep up with the snowfall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can you still see the road on your side?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I can, but I’m getting cold. What are we going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t have enough gas for them to pull over and try to wait it out, so he knew he had to keep going.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced over at Mary to see how she was doing. She was due at any time with their first child, and they were anxious to get back to their home in Clayton, New Mexico, so their family doctor could deliver the baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was trying to drive and look at a map to determine how far outside of Colorado Springs they were.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Watch out! You’re going to hit the post.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to swerve, but instead of turning away, they skidded into the road sign.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they hit the post, it pushed the radiator into the fan, stalling the motor. The impact ripped the post out of the ground, and wedged it into the front grille.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they slammed to a stop, Ben hit his head on the side of the window. The impact threw Mary off the seat and wedged her between the seat and the dashboard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As his head started to clear, he cried out, “Honey, are you all right? Are you hurt? Please get up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She struggled, trying to get her pregnant body back into the seat, but as she did, she went into labor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t feel very well. Please help me, I’m scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mind raced ahead to all the things that could go wrong, and then he remembered what his dad had always told him about worry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would say, “Some people waste their whole lives worrying. But the truth is eighty percent of the things they are worrying about never happen, and the other twenty percent they couldn’t have done anything to prevent anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He started to calm down and asked again, “Are you hurt?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My shoulder hurts, and I’m having cramps.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those aren’t cramps. It’s the baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It can’t come now. What are we going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to make her as comfortable as possible, and then he tried to start the car so he could get it back up on the road. As the engine tried to turn over, the fan made a horrible noise as it hit the radiator.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now he was worried. His young wife was in labor, and his car was lying wrecked in the bottom of a ditch in the middle of a blinding snowstorm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t sure how far it was to the nearest help, but he knew it was probably too far to walk in the snow. Not wanting her to worry, he told her. “I’ll get the post out of the radiator, and we’ll be on our way in just a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he worked to pull the signpost out of the grille, he noticed it said, "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("GLEN EYRIE 2 MILES")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once he removed the signpost, he used a tire tool to pry the radiator back from the fan as far as he could.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He got back in and tried to start the engine again. This time it started, but it was still making an awful racket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He decided even if he burned the motor out, he was going to try for the town on the sign.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re going to Glen Eyrie and get some help. I don’t know how big of a town it is, but they should at least have a phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was their first time through the area, so they didn’t know Glen Eyrie wasn’t a town. It was a luxury hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gunned the Suburban backward out of the ditch and onto the access road which ran along I-25. Once on the road, he turned down the narrow two-lane road toward Glen Eyrie.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he powered around the corner, he was praying. “Lord, please let me get Mary to this town, and let the baby be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was only two miles to Glen Eyrie, but it seemed like forever as the Suburban labored through the drifting snow. The wind was blowing at least forty miles an hour, and some of the drifts were already more than a foot deep. As he was straining to see through the blinding snow, he spotted the lights of Glen Eyrie.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We made it, honey, and everything is going to be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the lights became clear, he could see it wasn’t a town, it was a guard shack with two Marines inside. He pulled in, stopped beside the guard shack, and shut the Suburban off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A Marine sergeant stepped out into the blowing snow to find out what they wanted. Ben recognized the Heckler & Koch P9S nine-millimeter automatic on his hip and the Heckler & Koch MP5 machine gun on his shoulder. When he was in the Marines, the SEAL teams they trained with carried them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Marine stepped up to the running board and said, “This is a restricted area, and I’m going to have to ask you to turn around and go back to the main road.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ben didn’t know what to say, but he knew his old Suburban wouldn’t make it to Colorado Springs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My wife’s in labor. We were just in an accident. My car’s running hot, and it won’t make it to town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sergeant leaned in the window so he could get a better look. He saw Ben was telling the truth. Even though it was no more than ten degrees out, he could see the sweat rolling down her face, and it looked like she was in pain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sergeant wasn’t sure what to do. His orders clearly stated he was not to admit any civilians to the facility without prior clearance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to the guard shack, and called to the other Marine on duty with him. “Get the lieutenant on the intercom. I need to ask him what to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked at Ben and said, “Please wait here. I’m going to find out what I can do with you two.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lieutenant had just gotten an update on the weather forecast. There was a massive arctic weather system moving into the area, and the weather was only going to get worse for the next eight hours.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were supposed to have finished moving the facility today. Due to the worsening weather, he had put off the closing and the transfer of the artifact back to the Sandia facility until the weather system had passed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the sergeant called, he already knew the weather conditions were bad and getting worse by the minute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We have a couple of civilians at the front gate. Their Suburban is in bad shape, and the lady is in labor,” the sergeant said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lieutenant quickly made up his mind to allow them to enter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Send them up. No, wait. You lead them up so they don’t get lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sergeant hung up the phone and told the other Marine, “I’m going to lead these folks up to the castle. I’ll be back as soon as I get them checked in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Follow me, and I’ll take you up to Glen Eyrie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t tell you how much we appreciate this,” Ben West said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Suburban was still making horrible noises, but they managed to cover the mile or so to the castle.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722d9433","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765358493_ch01.vue
// module id = 81
// module chunks = 0